// import { compose, applyMiddleware, createStore } from 'redux';
// import thunk from 'redux-thunk';
// // to store data in redux //
// import { persistStore, persistReducer } from 'redux-persist'
// import storage from 'redux-persist/lib/storage'
// import reducers from './index';


// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;


// const persistConfig = {
//   key: 'root',
//   storage,
// }
// const persistedReducer = persistReducer(persistConfig, reducers)

// export const store = createStore(
//   persistedReducer,
//   composeEnhancers(
//     applyMiddleware(thunk)
//   )
// );

// export const persistor = persistStore(store)
import { configureStore } from '@reduxjs/toolkit';
import reducers from './index';

export default configureStore({
  reducer: reducers,
});